/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { WhiteSpace } from "antd-mobile";
import { FaListUl, FaThLarge } from "react-icons/fa";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import EmptyFavouriteSection from "./EmptyFavouriteSection";
import FavouriteListing from "../../components/FavouriteListing";
import * as selectors from "../../selectors";
import * as foodAction from "../../actions/food";
import * as favouriteAction from "../../actions/favourite";
import Theme from "../../utils/Theme";
import LoadingIndicator from "../../components/LoadingIndicator";

const StyledContainer = styled.div`
  max-width: ${Theme.MaxWidth};
  overflow-x: hidden;
  width: 100%;
  height: 100%;
`;

class FavouritePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      horizontalView: true
    };
  }

  componentDidMount() {
    const { authToken } = this.props;

    if (authToken) {
      this.fetchFavouriteFoodListData();
    }
    this.setupNavConfig();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.authToken !== this.props.authToken) {
      if (nextProps.authToken) {
        this.fetchFavouriteFoodListData();
      }
    }

    if (nextProps.favouriteFoodData !== this.props.favouriteFoodData) {
      const showRightIcon =
        nextProps.favouriteFoodData && nextProps.favouriteFoodData.length > 0;
      this.setupNavConfig(showRightIcon);
    }
  }

  setupNavConfig = (showRightIcon = false, horizontalView = true) => {
    const { showTabbar, showNavbar, navbarConfig } = this.props;

    navbarConfig(
      <FormattedMessage
        id="favourite.title"
        defaultMessage="My Favourite"
        description="Favourite page title"
      />,
      <div />,
      this.getNavbarRightIcon(showRightIcon, horizontalView),
      null,
      () => this.onRightIconClicked()
    );
    showNavbar(true);
    showTabbar(true);
  };

  getNavbarRightIcon = (showRightIcon, horizontalView) => {
    if (showRightIcon) {
      if (horizontalView) {
        return <FaThLarge />;
      }
      return <FaListUl />;
    }

    return null;
  };

  getLoadingIndicator = () => {
    const { favouriteFoodLoading, favouriteFoodHideLoading } = this.props;

    if (favouriteFoodHideLoading) {
      return null;
    }

    if (!favouriteFoodLoading) {
      return null;
    }

    return <LoadingIndicator />;
  };

  onRightIconClicked = () => {
    const { horizontalView } = this.state;
    const { favouriteFoodData } = this.props;
    const showRightIcon = favouriteFoodData && favouriteFoodData.length > 0;
    this.setState({
      horizontalView: !horizontalView
    });

    this.setupNavConfig(showRightIcon, !horizontalView);
  };

  onPressFavouriteItem = (foodID, isFavourite) => {
    const {
      favouriteFoodRequest,
      unFavouriteFoodRequest,
      authToken,
      history
    } = this.props;

    if (!authToken) {
      history.push("/auth/login");
      return;
    }

    if (isFavourite) {
      favouriteFoodRequest(foodID);
    } else {
      unFavouriteFoodRequest(foodID);
    }
  };

  onEndReached = () => {
    const { favouriteFoodPagination } = this.props;

    if (favouriteFoodPagination) {
      const { pageCount, currentPage } = favouriteFoodPagination;

      if (currentPage < pageCount) {
        this.fetchFavouriteFoodListData(currentPage + 1, true);
      }
    }
  };

  fetchFavouriteFoodListData = (pageNumber, hideLoading = false) => {
    const { getFavouriteFoodListDataRequest } = this.props;

    getFavouriteFoodListDataRequest(pageNumber, hideLoading);
  };

  render() {
    const { horizontalView } = this.state;
    const { favouriteFoodData, favouriteFoodLoading } = this.props;

    return (
      <StyledContainer>
        {this.getLoadingIndicator()}
        {favouriteFoodData && favouriteFoodData.length > 0 ? (
          <FavouriteListing
            {...this.props}
            items={favouriteFoodData}
            horizontalView={horizontalView}
            renderHeader={() => <WhiteSpace size={"md"} />}
            showFooterLoading={
              favouriteFoodLoading &&
              favouriteFoodData &&
              favouriteFoodData.length > 0
            }
            onEndReached={this.onEndReached}
            onFavouriteClicked={this.onPressFavouriteItem}
          />
        ) : (
          <EmptyFavouriteSection {...this.props} />
        )}
      </StyledContainer>
    );
  }
}

FavouritePage.propTypes = {
  intl: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  authToken: PropTypes.string,
  favouriteFoodData: PropTypes.array,
  favouriteFoodPagination: PropTypes.object,
  favouriteFoodLoading: PropTypes.bool,
  favouriteFoodHideLoading: PropTypes.bool,
  getFavouriteFoodListDataRequest: PropTypes.func,
  favouriteFoodRequest: PropTypes.func,
  unFavouriteFoodRequest: PropTypes.func
};

function mapStateToProps(state) {
  return {
    authToken: selectors.getAuthToken(state),
    favouriteFoodData: selectors.getFavouriteFoodListData(state),
    favouriteFoodPagination: selectors.getFavouriteFoodListPagination(state),
    favouriteFoodLoading: selectors.getFavouriteFoodListLoading(state),
    favouriteFoodHideLoading: selectors.getFavouriteFoodListHideLoading(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getFavouriteFoodListDataRequest: (pageNumber, hideLoading = false) =>
      dispatch(
        favouriteAction.getFavouriteFoodListRequest(pageNumber, hideLoading)
      ),
    favouriteFoodRequest: foodID =>
      dispatch(foodAction.favouriteFoodRequest(foodID)),
    unFavouriteFoodRequest: foodID =>
      dispatch(foodAction.unFavouriteFoodRequest(foodID))
  };
}

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(FavouritePage)
);



// WEBPACK FOOTER //
// ./src/containers/FavouritePage/index.js